// api/Statistics

import request from '@utils/request'

const url = 'api/Statistics/'

/**
 *
 * 获取管理员的概况数据，超级管理员、分销商、安装商通用（概况）
 * @export
 * @param {*} data
 * @return {*}
 */
export function GetManagerOverviewData (data) {
  return request({
    url: url + 'GetManagerOverviewData',
    method: 'post',
    data
  })
}

/**
 *
 * 获取终端用户的概览数据（光伏系统概述）
 * @export
 * @param {*} data
 * @return {*}
 */
export function GetTerminalOverviewData (data) {
  return request({
    url: url + 'GetTerminalOverviewData',
    method: 'post',
    data
  })
}

/**
 *
 * 获取电站的概览数据（组串电站 - 概览）
 * @export
 * @param {*} data
 * @return {*}
 */
export function GetClusterStationOverviewData (data) {
  return request({
    url: url + 'GetClusterStationOverviewData',
    method: 'post',
    data
  })
}

/**
 *
 * 获取指定组串逆变器的历史数据（电站 - 历史）
 * @export
 * @param {*} data
 * @return {*}
 */
export function GetClusterInvHistoryData (data) {
  return request({
    url: url + 'GetClusterInvHistoryData',
    method: 'post',
    data
  })
}

/**
 *
 * 获取组串电站的日报表数据（电站 - 报表）
 * @export
 * @param {*} data
 * @return {*}
 */
export function GetClusterDayReportData (data) {
  return request({
    url: url + 'GetClusterDayReportData',
    method: 'post',
    data
  })
}

/**
 *
 * 获取组串电站月和年报表数据（电站 - 报表/电站月年电量柱状图）
 * @export
 * @param {*} data
 * @return {*}
 */
export function GetClusterMYReportData (data) {
  return request({
    url: url + 'GetClusterMYReportData',
    method: 'post',
    data
  })
}

/**
 *
 * 组串电站报表导出
 * @export
 * @param {*} data
 * @return {*}
 */
export function ExpClusterReport (data) {
  return request({
    url: url + 'ExpClusterReport',
    method: 'post',
    data
  })
}

/**
 *
 * 获取储能电站的概览数据（储能电站 - 概览）
 * @export
 * @param {*} data
 * @return {*}
 */
export function GetStationOverviewData (data) {
  return request({
    url: url + 'GetStationOverviewData',
    method: 'post',
    data
  })
}

/**
 *
 * 电站比较（储能电站 - 电站对比）
 * @export
 * @param {*} data
 * @return {*}
 */
export function StationsCompare (data) {
  return request({
    url: url + 'StationsCompare',
    method: 'post',
    data
  })
}

/**
 *
 * 获取储能电站电量平衡图表数据（储能电站 - 电量平衡）
 * @export
 * @param {*} data
 * @return {*}
 */
export function GetStationEnergyBalanceChartData (data) {
  return request({
    url: url + 'GetStationEnergyBalanceChartData',
    method: 'post',
    data
  })
}

/**
 *
 * 获取设备历史数据（储能电站 - 历史 曲线图）
 * @export
 * @param {*} data
 * @return {*}
 */
export function GetInvHistoryData (data) {
  return request({
    url: url + 'GetInvHistoryData',
    method: 'post',
    data
  })
}

/**
 *
 * 获取储能电站的日报表数据（储能电站 - 报表）
 * @export
 * @param {*} data
 * @return {*}
 */
export function GetDayReportData (data) {
  return request({
    url: url + 'GetDayReportData',
    method: 'post',
    data
  })
}

/**
 *
 * 获取储能电站月和年的报表数据（储能电站 - 报表/电站月年电量柱状图）
 * @export
 * @param {*} data
 * @return {*}
 */
export function GetMYReportData (data) {
  return request({
    url: url + 'GetMYReportData',
    method: 'post',
    data
  })
}

/**
 *
 * 导出储能报表（储能电站 - 报表）
 * @export
 * @param {*} data
 * @return {*}
 */
export function ExpReport (data) {
  return request({
    url: url + 'ExpReport',
    method: 'post',
    data
  })
}

/**
 *
 * 获取组串电站功率曲线图数据
 * @export
 * @param {*} data
 * @return {*}
 */
export function GetStationPowerData (data) {
  return request({
    url: url + 'GetStationPowerData',
    method: 'post',
    data
  })
}

/**
 *
 * 获取组串电站概览页电量柱状图数据
 * @export
 * @param {object} data
 * @return {*}
 */
export function GetClusterStationEnergyChartData (data) {
  return request({
    url: url + 'GetClusterStationEnergyChartData',
    method: 'post',
    data
  })
}

